module.exports = __webpack_public_path__ + "media/newstyle/images/publish-book_es-6d142a0486474e31dabed6f0f8dc93c4.png";